import React, { useEffect, useState, useRef } from "react";
import SectionHeader from "./sectionheader";

const title = <h2 data-description="title">Why BAT Matrimony?</h2>;
const alignment = "section-header";

const countNumber = {
  AnnualMember: "200+",
  Volunteers: "200+",
  EventParticipants: "2000+",
  Sponsors: "10+",
};

const WhyBATSection = ({ isMainBat }) => {
  const [activated, setActivated] = useState(false);
  const countersRef = useRef([]);

  const formatCount = (count) => {
    if (count >= 1000) {
      return (count / 1000).toFixed(1) + "K" + "+"; // Format as "X.XK"
    }
    return count + "+";
  };

  const updateCounter = (counter, target) => {
    let count = 0;
    const increment = Math.ceil(target / 500); // Increment by a fraction of the target
    const interval = setInterval(() => {
      count += increment;
      if (count >= target) {
        clearInterval(interval);
        counter.innerText = formatCount(target); // Display formatted target
      } else {
        counter.innerText = formatCount(count); // Display formatted count
      }
    }, 10);
  };

  const handleScroll = () => {
    const container = document.querySelector(".counters");
    const counters = countersRef.current;

    if (
      window.scrollY > container.offsetTop - container.offsetHeight - 400 &&
      !activated
    ) {
      counters.forEach((counter) => {
        counter.innerText = 0;
        const target = parseInt(counter.dataset.count);
        updateCounter(counter, target);
      });
      setActivated(true);
    } else if (
      window.scrollY < container.offsetTop - container.offsetHeight - 500 ||
      (window.scrollY === 0 && activated)
    ) {
      counters.forEach((counter) => {
        if (counter) counter.innerText = 0;
      });
      setActivated(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activated]);

  return (
    <React.Fragment>
      <section className="whybat-section padding-tb bg-flower-img">
        <div className="container">
          {isMainBat ? (
            <div className="section-header">
              <h2
                data-description="title"
                className="color-red-bat-home mt-20 responsive-title text-center"
              >
                Why BAT Matrimony?
              </h2>
            </div>
          ) : (
            <SectionHeader
              title={title}
              alignment={alignment}
              isMainBa={isMainBat}
            />
          )}
          <div className="section-wrapper bg-white">
            <div className="counters shadow-lg">
              <div>
                <div className="counter">
                  <h1 className="counter-number">
                    <span
                      ref={(el) => (countersRef.current[0] = el)}
                      data-count={countNumber.AnnualMember}
                    >
                      0
                    </span>
                  </h1>
                  <p className="counter-text">Annual Member Families</p>
                </div>
                <div className="counter">
                  <h1>
                    <span
                      ref={(el) => (countersRef.current[1] = el)}
                      data-count={countNumber.Volunteers}
                    >
                      0
                    </span>
                  </h1>
                  <p className="counter-text">Volunteers</p>
                </div>
                <div className="counter">
                  <h1 className="counter-number">
                    <span
                      ref={(el) => (countersRef.current[2] = el)}
                      data-count={countNumber.EventParticipants}
                    >
                      0
                    </span>
                  </h1>
                  <p className="counter-text">Event Participants till Date</p>
                </div>
                <div className="counter">
                  <h1 className="counter-number">
                    <span
                      ref={(el) => (countersRef.current[3] = el)}
                      data-count={countNumber.Sponsors}
                    >
                      0
                    </span>
                  </h1>
                  <p className="counter-text">Sponsors</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="section-break"></div>
    </React.Fragment>
  );
};

export default WhyBATSection;
